import axios from "axios";
import authFirebase from "../../authFirebase";
const { ENDPOINT_API_CHATBOTS } = require("@/logic/globalEndpoints")


export default {



    //++++++++++++++++ Metodo GET para TRAER Info del USUARIO +++++++++++++++++++++++++
    async get_verify_create_chatbot(id_user) {

        const params = {
            id_user: id_user,
        };

        const headers = {
            Authorization: 'Bearer ' + await authFirebase.createTokenJWT()
        };

        const resp = await axios.get(ENDPOINT_API_CHATBOTS + "/api/verify/create-chatbot", { params, headers })
        return resp;
    },


    //++++++++++++++++ Metodo GET para TRAER Info del USUARIO +++++++++++++++++++++++++
    async post_verify_create_chatbot(id_user, id_chatbot) {

        const params = {
            id_user: id_user,
            id_chatbot: id_chatbot
        };

        const headers = {
            headers: { Authorization: 'Bearer ' + await authFirebase.createTokenJWT() }
        };

        console.log(params)
        const resp = await axios.post(ENDPOINT_API_CHATBOTS + "/api/verify/create-chatbot",  params, headers )
        return resp;
    },




}